import { ModuleWrapper } from '@/components'
import type { LinkListItem } from '@/components_deprecated'
import { LinkList } from '@/components_deprecated'
import { cn } from '@/lib/utils'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import { ChangePassword } from '.'
import { ChangeLanguage } from './ChangeLanguage'

interface UserSettingsProps {}

export const UserSettings: React.FC<UserSettingsProps> = () => {
  const translations = useTranslate({
    mySettings: 'settings.my-settings',
    userSettings: 'common.usersettings',
  })

  const links: LinkListItem[] = [
    {
      text: translations.userSettings,
      href: '/usersettings',
    },
  ]

  return (
    <ModuleWrapper title={translations.mySettings}>
      <div
        className={cn(
          'flex flex-col gap-4',
          'md:grid md:grid-cols-[1fr_3fr] md:grid-rows-[auto_auto] md:gap-8'
        )}
      >
        {!isMobileOnly && (
          <div className="md:col-1 md:row-span-full">
            <LinkList items={links} />
          </div>
        )}

        <ChangePassword />

        <ChangeLanguage />
      </div>
    </ModuleWrapper>
  )
}
